import { render, staticRenderFns } from "./expertReviewList.vue?vue&type=template&id=534ac029&scoped=true&"
import script from "./expertReviewList.vue?vue&type=script&lang=js&"
export * from "./expertReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ac029",
  null
  
)

export default component.exports